export {
  deriveMpQrPhase,
  mpQrCountdownSeconds,
  mpQrPollIntervalMs,
  shouldShowMpQrCloseConfirm,
  MP_QR_AUTO_CLOSE_MS,
  MP_QR_TTL_SECONDS,
  type MpQrPaymentPhase,
  type MpQrPaymentSnapshot,
} from './domain/mpQrPaymentPhase';

export { resolveFiscalInvoiceLabel } from './domain/mpQrFiscalLabel';

export { isPendingMercadoPagoQrSale } from './domain/isPendingMercadoPagoQrSale';
export { shouldBackfillMpQrOperationNumber } from './domain/mpQrSaleMetadata';

export {
  formatMpQrPendingBannerLabel,
  formatSyncFailedSalesBannerLabel,
  sumPendingMpQrAmount,
} from './application/posMpQrPendingPresentation';

export {
  listPendingMpQrSalesForBranch,
  type PendingMpQrSaleSummary,
} from './infra/pendingMpQrSalesRepo';

export {
  useMercadoPagoQrSession,
  type MercadoPagoQrSessionState,
  type UseMercadoPagoQrSessionOptions,
} from './application/useMercadoPagoQrSession';

export { MercadoPagoQrPaymentModal } from './components/MercadoPagoQrPaymentModal';
export type { MercadoPagoPosListItem, MercadoPagoPosListMeta, MercadoPagoPosPendingItem, MercadoPagoOAuthReturnShellRoute } from './infra/mercadopagoConnectService';

export {
  getSaleQr,
  rpcToSaleQrSnapshot,
  createMercadoPagoQrForSale,
  fetchMpQrPaymentStatus,
  fetchMercadoPagoQrPaymentAmount,
  syncMpQrPaymentStatusRemote,
} from './infra/mercadopagoQrService';

export { fetchMercadoPagoPosList, linkMercadoPagoPosForBranch, openMercadoPagoOAuthBrowser } from './infra/mercadopagoConnectService';

export {
  getMpIntegrationStatus,
  type MpIntegrationStatus,
} from './infra/mpSettingsRepo';

export {
  createMercadoPagoQrForCustomerPayment,
  getCustomerPaymentQrStatus,
  type CustomerPaymentQrCreateResponse,
  type CustomerPaymentQrStatusResponse,
} from './infra/customerPaymentQrService';
